// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
  apiKey: "AIzaSyDivXFyd_E7_mQzny6xj3u4B5WjMaDEhYY",
  authDomain: "hst-data.firebaseapp.com",
  databaseURL:
    "https://hst-data-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "hst-data",
  storageBucket: "hst-data.appspot.com",
  messagingSenderId: "935364080987",
  appId: "1:935364080987:web:81c0e558a8c86bb354567e",
  measurementId: "G-DYQQ1F48NM",
};

// Initialize Firebase
const AppConfig = initializeApp(firebaseConfig);
getAnalytics(AppConfig);

export default AppConfig;
